<template>
  <div
    class="hidden user-schedule__calendar-inner-box w-full lg:grid lg:grid-cols-7 lg:grid-rows-6 lg:gap-px"
  >
    <div
      v-for="day in days"
      :key="day.date"
      :class="[
        day.isCurrentMonth ? 'user-schedule__day--current-month' : '',
        day.isToday ? 'user-schedule__day--today' : '',
        'user-schedule__day relative'
      ]"
    >
      <time
        :datetime="day.date"
        :class="[
          day.isToday ? 'user-schedule__day__number--today' : undefined,
          'user-schedule__day__number'
        ]"
      >
        {{ day.date.split('-').pop()?.replace(/^0/, '') }}
      </time>
      <ol v-if="day.panelSessions.length > 0" class="user-schedule__day__session-list">
        <UserScheduleDayPanelListItem
          v-for="panelSession in day.panelSessions"
          :key="panelSession.id"
          :panel-session="panelSession"
        />
      </ol>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { UserScheduleDay } from '@/types/UserScheduleDay'
import UserScheduleDayPanelListItem from '@/components/UserSchedule/UserScheduleDayPanelListItem.vue'

defineProps<{
  days: UserScheduleDay[]
}>()
</script>
